import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Box,
  Typography,
  Tabs,
  Tab,
  Paper
} from '@mui/material';
import {
  PlaylistPlay,
  Dashboard
} from '@mui/icons-material';
import LeadFlowControl from '../components/leadflow/LeadFlowControl';
import LeadFlowDashboard from '../components/leadflow/LeadFlowDashboard';
import LeadFlowControlDashboard from '../components/leadflow/LeadFlowControlDashboard';
import ErrorAlert from '../components/common/ErrorAlert';

const LeadFlow = () => {
  const { user: currentUser } = useSelector((state) => state.auth);
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  // Check if user has permission to access lead flow control
  const canControlLeadFlow = currentUser?.role === 'admin' || 
                             currentUser?.role === 'manager' || 
                             currentUser?.role === 'team_lead';

  if (!canControlLeadFlow) {
    return (
      <Box>
        <Typography variant="h4" gutterBottom>
          Lead Flow Management
        </Typography>
        <ErrorAlert 
          error="You don't have permission to access lead flow controls. This feature is available for Team Leads, Managers, and Admins only." 
        />
      </Box>
    );
  }

  return (
    <Box>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <PlaylistPlay color="primary" />
          Lead Flow Management
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Monitor and control lead flow distribution across your team
        </Typography>
      </Box>

      {/* Tabs */}
      <Paper sx={{ mb: 3 }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          aria-label="lead flow management tabs"
          sx={{ px: 2 }}
        >
          <Tab
            icon={<Dashboard />}
            label="Control Dashboard"
            iconPosition="start"
            sx={{ minHeight: 48 }}
          />
          <Tab
            icon={<Dashboard />}
            label="Analytics Dashboard"
            iconPosition="start"
            sx={{ minHeight: 48 }}
          />
          <Tab
            icon={<PlaylistPlay />}
            label="Flow Control"
            iconPosition="start"
            sx={{ minHeight: 48 }}
          />
        </Tabs>
      </Paper>

      {/* Tab Content */}
      {activeTab === 0 && <LeadFlowControlDashboard />}
      {activeTab === 1 && <LeadFlowDashboard />}
      {activeTab === 2 && <LeadFlowControl />}
    </Box>
  );
};

export default LeadFlow;